import { render, staticRenderFns } from "./TaskPriorityDisplay.vue?vue&type=template&id=230da1fe"
import script from "./TaskPriorityDisplay.vue?vue&type=script&lang=js"
export * from "./TaskPriorityDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports